export enum FeedbackMessage {
  NONE = '',
  UNKNOWN_ERROR = 'Oops! An error occurred. Please refresh and try again.',
  UNAUTHORIZED = "We don't recognize your email. Please sign up!",
  REGISTER_ALREADY = "You're already registered! Please login to continue",
}
